import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { ContentProvider } from "@/context/ContentContext";
import { Toaster } from "sonner";
import ScrollToTop from "@/components/ScrollToTop";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Services from "@/pages/Services";
import Gallery from "@/pages/Gallery";
import WeddingsPortfolio from "@/pages/WeddingsPortfolio";
import WeddingDetail from "@/pages/WeddingDetail";
import EventsPortfolio from "@/pages/EventsPortfolio";
import EventDetail from "@/pages/EventDetail";
import FAQ from "@/pages/FAQ";
import Quote from "@/pages/Quote";
import StaffLogin from "@/pages/StaffLogin";
import Dashboard from "@/pages/Dashboard";

function PublicLayout({ children }) {
  return (
    <>
      <Navbar />
      <main>{children}</main>
      <Footer />
    </>
  );
}

function ProtectedRoute({ children }) {
  const { user, ready } = useAuth();
  if (!ready) return <div className="min-h-screen flex items-center justify-center text-[#8a8a80] tracking-[0.2em] uppercase text-sm">Loading…</div>;
  if (!user) return <Navigate to="/staff-login" replace />;
  return children;
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <ContentProvider>
          <ScrollToTop />
          <Toaster position="top-center" />
          <Routes>
            <Route path="/" element={<PublicLayout><Home /></PublicLayout>} />
            <Route path="/home" element={<PublicLayout><Home /></PublicLayout>} />
            <Route path="/about" element={<PublicLayout><About /></PublicLayout>} />
            <Route path="/services" element={<PublicLayout><Services /></PublicLayout>} />
            <Route path="/gallery" element={<PublicLayout><Gallery /></PublicLayout>} />
            <Route path="/weddings" element={<PublicLayout><WeddingsPortfolio /></PublicLayout>} />
            <Route path="/weddings/:id" element={<PublicLayout><WeddingDetail /></PublicLayout>} />
            <Route path="/events" element={<PublicLayout><EventsPortfolio /></PublicLayout>} />
            <Route path="/events/:id" element={<PublicLayout><EventDetail /></PublicLayout>} />
            <Route path="/faqs" element={<PublicLayout><FAQ /></PublicLayout>} />
            <Route path="/quote" element={<PublicLayout><Quote /></PublicLayout>} />
            <Route path="/staff-login" element={<StaffLogin />} />
            <Route path="/staff/login" element={<Navigate to="/staff-login" replace />} />
            <Route path="/staff/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </ContentProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
